export const buildingSettingsModelGet = () => {
    return {
        accountsPayable: {
        },
        accountsReceivable: {
            aliquotPercentage: false,
        },
        bankAccounts: {
        },
        collectionCashes: {
        },
        users: {
            maxLockoutAttemps: 0,
        },
    };
}